// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"Addons_with-ellipsis---sb","withEllipsis":"Addons_with-ellipsis---sb","addons":"Addons_addons---sb","headers":"Addons_headers---sb","header":"Addons_header---sb","sub-header":"Addons_sub-header---sb","subHeader":"Addons_sub-header---sb","list":"Addons_list---sb","actions":"Addons_actions---sb","action-btn":"Addons_action-btn---sb","actionBtn":"Addons_action-btn---sb","confirm-btn":"Addons_confirm-btn---sb","confirmBtn":"Addons_confirm-btn---sb","cancel-btn":"Addons_cancel-btn---sb","cancelBtn":"Addons_cancel-btn---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/styles.less
// module id = 1616
// module chunks = 0